import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import EmpPos from "./EmpPos";
import EmpAllOrders from "./EmpAllOrders";

// POS and Orders stay mounted so switching tabs keeps the menu and cart instead
// of loading everything again. Other pages (order confirmation) replace them,
// which also gives the POS a fresh start after an order.
const SalesLayout: React.FC = () => {
  const path = useLocation().pathname.toLowerCase().replace(/\/+$/, "");
  const onPos = path === "/sales";
  const onOrders = path === "/sales/all-orders";
  const isTab = onPos || onOrders;

  const [ordersOpened, setOrdersOpened] = useState(onOrders);
  useEffect(() => {
    if (onOrders) setOrdersOpened(true);
    else if (!isTab) setOrdersOpened(false);
  }, [onOrders, isTab]);

  if (!isTab) return <Outlet />;

  return (
    <>
      <div className={onPos ? "" : "hidden"}>
        <EmpPos />
      </div>
      {(ordersOpened || onOrders) && (
        <div className={onOrders ? "" : "hidden"}>
          <EmpAllOrders active={onOrders} />
        </div>
      )}
    </>
  );
};

export default SalesLayout;
